import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UtilsService } from './utils.service';
import { SubscriptionService } from './subscription.service';
import { Router } from '@angular/router';

@Injectable()
export class Interceptor implements HttpInterceptor {

  constructor(
    private utilsService: UtilsService,
    private router: Router,
    private subscriptionService: SubscriptionService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // URLs exclues du token
    const excludedUrls = [
      "/login", "/get-devis-by-type-produit", 
      "/type-produit", "/souscripteurs", "/garantie", "/souscripteurs/activate-account", 
      "/users/request-reset-password", "/users/reset-password", "/categorie-vehicule", 
      "/moyens-de-paiement", "/vehicle-model/get-make", "/vehicle-model/get-model-by-make", 
      "/produits", "/durees", 'type-garantie/list-garanties', "/garantie", 
      "/parametrage-mrh/get-price", "/me-rappeller", "/plainte", 
      "/params-gens", "/newsletters"
    ];

    // Vérifier si l'URL doit être exclue
    const isExcluded = excludedUrls.some(url => request.url.includes(url));

    if (!isExcluded) {
      const storedData = localStorage.getItem('microFinance');
      if (storedData) {
        const token = JSON.parse(storedData).id_token;
        if (token) {
          const headers: any = {
            Authorization: `Bearer ${token}`,
            'Access-Control-Allow-Origin': '*',
          };
          
          if (!(request.body instanceof FormData)) {
            headers['Content-Type'] = 'application/json';
          }
          
          request = request.clone({
            setHeaders: headers
          });
        }
      }
    }

    return next.handle(request).pipe(
      catchError((response: HttpErrorResponse) => {
        if (response.status === 401) {
           this.handleUnauthorized();
        }
        return throwError(response);
      })
    );
  }

  private handleUnauthorized() {
    // this.utilsService.showToastSuccess("Votre session a expiré", "Veuillez vous reconnecter");
    localStorage.removeItem('microFinance');
    this.router.navigate(['/']);
  }
}
